export default "__VITE_ASSET__BTYCvkZq__"